import { useAppSelector } from 'shared/lib/store';
import { FC, FocusEvent, useEffect, useState } from 'react';
import {
	selectTagsForOrder,
	selectTagsForOrderMap,
	selectTagsForPerson,
	selectTagsForPersonMap,
} from 'entities/tags';
import { Option } from 'shared/types';
import { SelectTag } from 'shared/ui/select/selectTag';
import { MultiValue } from 'react-select';
import { useBookingReset } from 'features/booking/BookingClientForm';

interface TagsOptionsProps {
	isForOrder?: boolean;
	tagsOptions?: string[];
	onSelect?: (value: MultiValue<Option>) => void;
  onFocus?: (e: FocusEvent, selector?: string) => void;
	readonly?: boolean;
}

export const TagsOptions: FC<TagsOptionsProps> = ({
	isForOrder = false,
	tagsOptions,
	onSelect,
	readonly = false,
  onFocus
}) => {
	const [options, setOptions] = useState<Option[]>([]);
	const [values, setValues] = useState<Option[]>([]);

	const tags = useAppSelector(
		isForOrder ? selectTagsForOrder : selectTagsForPerson,
	);
	const tagsForPerson = useAppSelector(selectTagsForPersonMap);
	const tagsForOrder = useAppSelector(selectTagsForOrderMap);

	useEffect(() => {
		setOptions(
			tags.map(tag => ({
				color: tag.color,
				value: tag.id?.toString(),
				label: tag.name,
			})),
		);
	}, [tags]);

	useEffect(() => {
		setValues([]);
		if (tagsOptions) {
			const options: Option[] = [];
			tagsOptions.forEach(tag => {
				const option: Option & { color: string } = { value: '', label: '', color: '' };

				if (!isForOrder) {
					const tagValue = tagsForPerson.get(tag);
					if (tagValue) {
						option.value = tagValue.value;
						option.color = tagValue.color;
					}
				} else {
					const tagValue = tagsForOrder.get(tag);
					if (tagValue) {
						option.value = tagValue.value;
						option.color = tagValue.color;
					}
				}

				option.label = tag;
				options.push(option);
			});

			setValues(options);
		}
	}, [tagsOptions, isForOrder, tagsForPerson, tagsForOrder]);

	const select = (value: MultiValue<unknown>) => {
		onSelect && onSelect(value as MultiValue<Option>);
	};

	useBookingReset(() => {
		setValues([]);
	})

	return (
		<SelectTag
			options={options}
			value={values}
			readonly={readonly}
			onSelect={select}
			placeholder="Выберите теги"
      onFocus={onFocus}
		/>
	);
};
